import { Object, Array, String, Static, Optional } from '@sinclair/typebox';

export const ConfirmationEmailRequestBody = Object({
  orderId: String(),
  recipients: Array(String()),
});
export type ConfirmationEmailRequestBody = Static<typeof ConfirmationEmailRequestBody>;

export const ConfirmationEmailResponse = Object({
  message: Optional(String()),
  successfulRecipients: Array(String()),
  failedRecipients: Array(
    Object({
      recipient: String(),
      error: String(),
    })
  ),
});
export type ConfirmationEmailResponse = Static<typeof ConfirmationEmailResponse>;
